class ExpressSelectedDialogContentController {
    constructor(settings, expressService) {
        this.settings = settings;
        this.expressService = expressService;
    }

    $onInit() {
        this.dialogCtrl.show();
        this.expressService.setHideExpressDialogInStorage();
        this.isETAEnabled = this.settings.expressLandingPage.expressETAEnabled;
    }
}

ExpressSelectedDialogContentController.$inject = ['Settings', 'ExpressService'];

const expressSelectedDialogContentControllerComponentDefinition = {
    template: require('./express-selected-dialog-content.component.html').trim(),
    require: { dialogCtrl: '^dialog' },
    controller: ExpressSelectedDialogContentController,
};

module.exports = {
    ExpressSelectedDialogContentController,
    expressSelectedDialogContentControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/express/dialog/express-selected-dialog-content.component.js